import { useEffect } from "react";

import { Outlet, useLocation, useNavigate } from "react-router-dom";
import FooterComponent from "../components/footer/footer";
import HeaderComponent from "../components/header";
import SidebarComponent from "../components/sidebar/sidebar";
import { consoleLog } from "../services/common/utils";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const SubPageRoute = ({ type }) => {
  const tokenid = useSelector((state) => state?.userdata?.value?.tokenid);
  const navigate = useNavigate();
  const location = useLocation();
  const {t} = useTranslation();
  //consoleLog("--subroute--");
  const pathString = location?.pathname?.split("/")[1];
  if (type === 1) {
    const pageToHaveThemeHeader = [
      '/more',
    ];
    const haveThemeHeader = pageToHaveThemeHeader.includes(location.pathname);
    // for more new pages implementation
    const pageRoutesToNotConsiderWithHeader = [
      '/more', 
      '/my-account', 
      '/my-payments', 
      '/terms-and-conditions', 
      '/personal-info',
      '/password-management',
      '/delete-account',
      '/transaction-history',
      '/transaction-detail',
      '/my-cards',
      '/payment-method',

      // call-details
      '/verification-otp',
      '/verification-paci',
      '/verification-confirmation',
      '/choose',
      '/call-details',
      '/verification'
    ];
    const hideHeader = pageRoutesToNotConsiderWithHeader.includes(location.pathname);

    const pagesWithoutFooter = [
      "/delete-account",
      "/personal-info",
      "/password-management",
      "/transaction-detail",

      // call-details
      '/verification-otp',
      '/verification-paci',
      '/verification-confirmation',
      '/choose',
      '/call-details',
      '/verification'
    ];
    const hideFooter = pagesWithoutFooter.includes(location.pathname);

    const pagesWithBg = [
      '/more', 
      '/my-account', 
      '/my-payments', 
      '/terms-and-conditions', 
      '/personal-info',
      '/password-management',
      '/delete-account',
      '/transaction-history',
      '/transaction-detail',
      '/my-cards',
      '/payment-method',

      // call-details
      '/verification-otp',
      '/verification-paci',
      '/verification-confirmation',
      '/choose',
      '/call-details',
      '/verification'      
    ]
    const showPageBg = pagesWithBg.includes(location.pathname);

    let makePageHeaderHidden  = false; 
    if(!tokenid && location.pathname === '/more'){
      makePageHeaderHidden = true;
    }
    
    return ( 
      // <div>
      //   <div>
      //     <div style={{ height: '1000px', backgroundColor: 'red'}}>See</div>
      //     <p style={{backgroundColor: 'yellow'}}>See</p>
      //   </div>
      // </div>
      <div id="container_main" className="body_container post_login">
        {location.pathname === "/recharge" ? (
          <HeaderComponent type={4}></HeaderComponent>
        ) : location.pathname === "/changepassword" ? (
          <HeaderComponent type={5} name="changepassword"></HeaderComponent>
        ) : 
          location.pathname === "/deleteaccount" ? (
          <HeaderComponent type={5} name="deleteaccount"></HeaderComponent>
        ) : location.pathname === "/deletedetails" ? (
          <HeaderComponent type={5} name="deleteaccount"></HeaderComponent>
        ) : (pathString === 'offer-detail' || pathString === 'shared-offer-details' || pathString === 'cvm-offer-detail') ? (
          <HeaderComponent type='2A' showBack={true}></HeaderComponent>
        ) : location.pathname == "/managecards" ? (
          <HeaderComponent type={5} name="paymentmethod"></HeaderComponent>
        ): location.pathname.includes("/recent-Transaction") ? (
          <HeaderComponent type={28}></HeaderComponent>
        ) : hideHeader ? (
          <></>
        ) : (
          <HeaderComponent type={3}></HeaderComponent>
        )}
        <SidebarComponent></SidebarComponent>
        <section id="content_cont" className={`app_main_wrapper ${haveThemeHeader ? '' : 'pt-60'} ${makePageHeaderHidden ? 'pt-60' : ''} pb-76 d-flex flex-column ${showPageBg ? 'sprint16bg' : ''} ${location.pathname === '/call-details' ? 'call-details-pg-h100' : ''}`}>
        {/* <div style={{height: '800px', background: 'yellow'}}> </div> */}
          <div className="center_section">
            <div className="sec_top">
              <Outlet />
            </div>
          </div>
        </section>
        {location.pathname === "/recharge" ||
        location.pathname === "/changepassword" ||
        location.pathname === "/deleteaccount" ||
        location.pathname === "/deletedetails" || hideFooter ? null : (
          <FooterComponent></FooterComponent>
        )}
      </div>
    );
  }

  if (type === 2) {
    return (
      <div id="container_main" className="body_container post_login">
        <HeaderComponent type={5}></HeaderComponent>
        <SidebarComponent></SidebarComponent>
        <section id="content_cont" className="app_main_wrapper pt-60 pb-76 d-flex flex-column">
          <div className="center_section">
            <div className="sec_top">
              <Outlet />
            </div>
          </div>
        </section>
        {/* <FooterComponent></FooterComponent> */}
      </div>
    );
  }

  if (type === 3) {
    const pageToHaveThemeHeader = [
      '/more',
    ];
    const haveThemeHeader = pageToHaveThemeHeader.includes(location.pathname);
    const pageRoutesToNotConsiderWithHeader = [
      '/more',
      '/terms-and-conditions'
    ];
    const hideHeader = pageRoutesToNotConsiderWithHeader.includes(location.pathname);
    const pagesWithBg = [
      '/more',
      '/terms-and-conditions', 
    ]
    const showPageBg = pagesWithBg.includes(location.pathname);

    let makePageHeaderHidden  = false; 
    if(!tokenid && location.pathname === '/more'){
      makePageHeaderHidden = true;
    }
    
    return (
      // <div>
      //   <div>
      //     <div  style={{ height: '1000px', backgroundColor: 'red'}}>See</div>
      //     <p style={{backgroundColor: 'yellow'}}>See</p>
      //   </div>
      // </div>
      <div id="container_main" className="body_container post_login">
        {location.pathname === "/recharge" ? (
          <HeaderComponent type={4}></HeaderComponent>
        ) : location.pathname === "/paybill" ? (
          <HeaderComponent type={13}></HeaderComponent>
        ) : location.pathname === "/moremenu" || hideHeader ? (
          <></>
        ) : location.pathname === "/promotionsviewall" ? (
          <HeaderComponent type={29}></HeaderComponent>
        ) :(
          <HeaderComponent type={8}></HeaderComponent>
        )}

        <SidebarComponent></SidebarComponent>
        <section id="content_cont" className={`app_main_wrapper ${haveThemeHeader ? '' : 'pt-60'} ${makePageHeaderHidden ? 'pt-60' : ''} pb-76 d-flex flex-column ${showPageBg ? 'sprint16bg' : ''}`}>
        {/* <div style={{height: '800px', background: 'yellow'}}> </div> */}
          <div className="center_section">
            <div className="sec_top">
              <Outlet />
            </div>
          </div>
        </section>
        <FooterComponent></FooterComponent>
      </div>
    );
  }

  if (type === 4) {
    return (
      <div id="container_main" className="body_container post_login">
        <HeaderComponent type={14}></HeaderComponent>
        <SidebarComponent></SidebarComponent>
        <section id="content_cont" className="app_main_wrapper pt-60 pb-76 d-flex flex-column">
          <div className="center_section">
            <div className="sec_top">
              <Outlet />
            </div>
          </div>
        </section>
        {/* <FooterComponent></FooterComponent> */}
      </div>
    );
  }
  if (type === 5) {
    const pageToHaveThemeHeader = [
      '/paybill',
    ];
    const haveThemeHeader = pageToHaveThemeHeader.includes(location.pathname);
    return (
      <div id="container_main" className="body_container post_login">
        {/* <HeaderComponent type={13}></HeaderComponent> */}
        <SidebarComponent></SidebarComponent>
        <section id="content_cont" className={`app_main_wrapper pb-76 d-flex flex-column ${haveThemeHeader ? '' : 'pt-60'}`}>
          <div className="center_section">
            <div className="sec_top">
              <Outlet />
            </div>
          </div>
        </section>
        <FooterComponent></FooterComponent>
      </div>
    );
  }
  if (type === 6) {
    const pagesWithoutFooter = [
      "/nojoom-buypoints",
      "/load-balance",
      "/smart-pay-cards",
      "/smart-pay-edit-cards",
      "/smart-pay-numbers",
      "/smart-pay-edit-numbers",
    ];

    const pagesWithoutExtra_pb_mb_css = [
      "/share-offer",
      '/manage-account'
    ];

    const showFooter = !pagesWithoutFooter.includes(location.pathname);
    const showExtra_pb_mb_css = !pagesWithoutExtra_pb_mb_css.includes(location.pathname);

    return (
      <div id="container_main" className="body_container post_login">
        {location.pathname === "/nojoom-buypoints" ? (
          <HeaderComponent type={15} name="nojoom-buypoints"></HeaderComponent>
        ) : (
          <HeaderComponent type={15}></HeaderComponent>
        )}
        <SidebarComponent></SidebarComponent>
        <section id="content_cont" className="app_main_wrapper pt-60 pb-76 d-flex flex-column">
          <div className={`center_section ${showExtra_pb_mb_css ? 'mb-5 pb-5' : ''}`}>
            <div className="sec_top">
              <Outlet />
            </div>
          </div>
        </section>

        {showFooter && <FooterComponent></FooterComponent>}
      </div>
    );
  }

  if (type === 7) {
    const pageToHaveThemeHeader = [
      '/paybill',
    ];
    const haveThemeHeader = pageToHaveThemeHeader.includes(location.pathname);
    return (
      <div id="container_main" className="body_container post_login">
        {/* <HeaderComponent type={3}></HeaderComponent> */}
        <SidebarComponent></SidebarComponent>
        <section id="content_cont" className={`app_main_wrapper pb-76 d-flex flex-column ${haveThemeHeader ? '' : 'pt-60'}`}>
          <div className="center_section">
            <div className="sec_top">
              <Outlet />
            </div>
          </div>
        </section>
        <FooterComponent></FooterComponent>
      </div>
    );
  }

  if (type === 8) {
    // for support new pages
    const pageRoutesToNotConsiderWithHeader = [
      '/support', 
      '/help-articles-list', 
      '/help-articles-list-detail', 
      '/need-help-list', 
      '/network-and-internet-list',
      '/network-and-internet-list-detail',
      '/payments',
      '/your-bill',
      '/track-complaints',
      '/ooredoo-pedia',
      '/sprint-16-components'
    ];
    const hideHeader = pageRoutesToNotConsiderWithHeader.includes(location.pathname);

    const pagesWithFooter = [
      "/need-help-list",
      "/network-and-internet-list",
      "/payments",
      "/your-bill",
      "/help-articles-list",
      "/ooredoo-pedia",
      "/sprint-16-components"
    ];
    const showFooter = pagesWithFooter.includes(location.pathname);

    const pagesWithBg = [
      "/support",
      '/support-assistant',
      "/payments",
      '/your-bill',
      '/track-complaints',
      '/ooredoo-pedia',
    ]

    const showPageBg = pagesWithBg.includes(location.pathname);

    return (
      <div id="container_main" className="body_container post_login">
        {
          hideHeader ? (
            <></>
          ) : (
            <HeaderComponent type={14}></HeaderComponent>
          )
        }

        <SidebarComponent></SidebarComponent>
        <section id="content_cont" className={`app_main_wrapper pt-60 pb-76 d-flex flex-column ${showPageBg ? 'sprint16bg': ''}`}>
          <div className="center_section">
            <div className="sec_top">
              <Outlet />
            </div>
          </div>
        </section>
        {
          showFooter && (
            <FooterComponent></FooterComponent>
          )
        }
      </div>
    );
  }
  if (type === 9) {
    return (
      <div id="container_main" className="body_container post_login">
        {location.pathname === "/recharge" ? (
          <HeaderComponent type={4}></HeaderComponent>
        ) : location.pathname === "/paybill" ? (
          <HeaderComponent type={13}></HeaderComponent>
        ) : location.pathname == "/managecards" ? (
          <HeaderComponent type={5} name="paymentmethod"></HeaderComponent>
        ) : (
          <HeaderComponent type={17}></HeaderComponent>
        )}

        <SidebarComponent></SidebarComponent>

        <section id="content_cont" className="app_main_wrapper pt-60 pb-76 d-flex flex-column">
          <div className="center_section">
            <div className="sec_top">
              <Outlet />
            </div>
          </div>
        </section>

        {location.pathname === "/recharge" ? null : location.pathname === "/payviavoucher" ?  null : (
          <FooterComponent></FooterComponent>
        )}
      </div>
    );
  }
  if (type === 10) {
    return (
      <div id="container_main" className="body_container post_login">
        <HeaderComponent type={18}></HeaderComponent>
        <SidebarComponent></SidebarComponent>

        <section id="content_cont" className="app_main_wrapper pt-60 pb-76 d-flex flex-column">
          <div className="center_section">
            <div className="sec_top">
              <Outlet />
            </div>
          </div>
        </section>

        <FooterComponent></FooterComponent>
      </div>
    );
  }
  if (type === 11) {
    return (
      <div id="container_main" className="body_container post_login">
        <HeaderComponent type={19}></HeaderComponent>
        <SidebarComponent></SidebarComponent>

        <section id="content_cont" className="app_main_wrapper pt-60 pb-76 d-flex flex-column">
          <div className="center_section">
            <div className="sec_top">
              <Outlet />
            </div>
          </div>
        </section>

        <FooterComponent></FooterComponent>
      </div>
    );
  }
  if (type === 12) {
    return (
      <div id="container_main" className="body_container post_login">
        <HeaderComponent type={20}></HeaderComponent>
        <SidebarComponent></SidebarComponent>

        <section id="content_cont" className="app_main_wrapper pt-60 pb-76 d-flex flex-column">
          <div className="center_section">
            <div className="sec_top">
              <Outlet />
            </div>
          </div>
        </section>

        <FooterComponent></FooterComponent>
      </div>
    );
  }
  if (type === 13) {
    return (
      <div id="container_main" className="body_container post_login">
        <HeaderComponent type={21}></HeaderComponent>
        <SidebarComponent></SidebarComponent>

        <section id="content_cont" className="app_main_wrapper pt-60 pb-76 d-flex flex-column">
          <div className="center_section">
            <div className="sec_top">
              <Outlet />
            </div>
          </div>
        </section>

        <FooterComponent></FooterComponent>
      </div>
    );
  }
  if (type === 14) {
    return (
      <div id="container_main" className="body_container post_login">
        {/* <HeaderComponent type={22}></HeaderComponent> */}
        <SidebarComponent></SidebarComponent>

        <section id="content_cont" className="app_main_wrapper pt-60 pb-76 d-flex flex-column">
          <div className="center_section">
            <div className="sec_top">
              <Outlet />
            </div>
          </div>
        </section>

        <FooterComponent></FooterComponent>
      </div>
    );
  }
  // if (type === 14) {
  //   return (
  //     <div className="body_container post_login">
  //       <HeaderComponent type={22}></HeaderComponent>
  //       <SidebarComponent></SidebarComponent>

  //       <section className="app_main_wrapper pt-60 pb-76 d-flex flex-column">
  //         <div className="center_section">
  //           <div className="sec_top">
  //             <Outlet />
  //           </div>
  //         </div>
  //       </section>

  //       <FooterComponent></FooterComponent>
  //     </div>
  //   );
  // }
  if (type === 15) {
    return (
      <div id="container_main" className="body_container post_login">
        <HeaderComponent type={23}></HeaderComponent>
        <SidebarComponent></SidebarComponent>

        <section id="content_cont" className="app_main_wrapper pt-60 pb-76 d-flex flex-column">
          <div className="center_section">
            <div className="sec_top">
              <Outlet />
            </div>
          </div>
        </section>

        <FooterComponent></FooterComponent>
      </div>
    );
  }

  if (type === 16) {
    const path_background_execeptions = ['/country_details_packs/', '/roaming-international-rates'];
    const isPaddingbottom  = path_background_execeptions?.filter(item => location.pathname?.match(item))?.length > 0
    return (
      <div id="container_main" className="body_container post_login">
        <HeaderComponent type={5}></HeaderComponent>
        <SidebarComponent></SidebarComponent>
        <section id="content_cont" className={`app_main_wrapper pt-60  d-flex flex-column ${isPaddingbottom ? '':'pb-76'}`}>
          <div className="center_section">
            <div className="sec_top">
              <Outlet />
            </div>
          </div>
        </section>
        <FooterComponent></FooterComponent>
      </div>
    );
  }
  //for MVP2 Release1 already type==16 is added, so need to add new type where we are using "16" in MVP2 Release2
  // if (type === 16) {
  //     const pagesWithoutFooter = ['/nojoom-buypoints', '/load-balance'];
  //     const showFooter = !pagesWithoutFooter.includes(location.pathname);
  //     return (
  //         <div className="body_container post_login">

  //             <HeaderComponent type={24}></HeaderComponent>
  //             <SidebarComponent></SidebarComponent>
  //             <section className="app_main_wrapper pt-60 pb-76 d-flex flex-column">
  //                 <div className="center_section mb-5 pb-5">
  //                     <div className="sec_top">
  //                         <Outlet />
  //                     </div>
  //                 </div>
  //             </section>
  //             {
  //                 showFooter && (
  //                     <FooterComponent></FooterComponent>
  //                 )
  //             }
  //         </div>
  //     );
  // }
  if (type === 17) {
    const pagesWithoutFooter = ["/nojoom-buypoints", "/load-balance"];
    const showFooter = !pagesWithoutFooter.includes(location.pathname);

    return (
      <div id="container_main" className="body_container post_login">
        <HeaderComponent type={25}></HeaderComponent>
        <SidebarComponent></SidebarComponent>
        <section id="content_cont" className="app_main_wrapper pt-60 pb-76 d-flex flex-column">
          <div className="center_section mb-5 pb-5">
            <div className="sec_top">
              <Outlet />
            </div>
          </div>
        </section>

        {showFooter && <FooterComponent></FooterComponent>}
      </div>
    );
  }
  if (type === 18) {
    const pagesWithoutFooter = ["/nojoom-buypoints", "/load-balance"];
    const showFooter = !pagesWithoutFooter.includes(location.pathname);
    return (
      <div id="container_main" className="body_container post_login">
        <HeaderComponent type={24}></HeaderComponent>
        <SidebarComponent></SidebarComponent>
        <section id="content_cont" className="app_main_wrapper pt-60 pb-76 d-flex flex-column">
          <div className="center_section mb-5 pb-5">
            <div className="sec_top">
              <Outlet />
            </div>
          </div>
        </section>
        {showFooter && <FooterComponent></FooterComponent>}
      </div>
    );
  }

  //request credit
  if (type === 19) {
    return (
      <div id="container_main" className="body_container post_login">
        <HeaderComponent type={15}></HeaderComponent>

        <SidebarComponent></SidebarComponent>
        <section id="content_cont" className="app_main_wrapper pt-60 pb-76 d-flex flex-column">
          <div className="center_section">
            <div className="sec_top">
              <Outlet />
            </div>
          </div>
        </section>
        {/* <FooterComponent></FooterComponent> */}
      </div>
    );
  }
  if (type === 20) {
    return (
      <div id="container_main" className="body_container">
        <HeaderComponent type={27}></HeaderComponent>
        
        <section id="content_cont" className="app_main_wrapper pt-60 pb-76 d-flex flex-column">
          <div className="center_section">
            <div className="sec_top">
              <Outlet />
            </div>
          </div>
        </section>
        {/* <FooterComponent></FooterComponent> */}
      </div>
    );
  }
  if (type === 21) {
    return (
      <div id="container_main" className="body_container post_login ">
        <HeaderComponent type={5} name={t("Roaming")}></HeaderComponent>
        <SidebarComponent></SidebarComponent>
        <section id="content_cont" className="app_main_wrapper pt-60 d-flex flex-column">
          <div className="center_section">
            <div className="sec_top">
              <Outlet />
            </div>
          </div>
        </section>
        <FooterComponent></FooterComponent>
      </div>
    );
  }
};

export default SubPageRoute;
